export const environment = {
  production: false,
  baseUrl: "https://lionfish-app-mo3rs.ondigitalocean.app",
  hostName: () => window.location.hostname.replace("www.", ""),
  cloudinaryCloudName: "dcxfz369a",
  cloudinaryPreset: "afrf4saz",
};
